module.exports = __webpack_public_path__ + "img/p-23.1e13fc98.png";